<template>
  <div
    class="messenger-chat-survey-log-message-layout"
    :class="`messenger-chat-survey-log-message-layout--${rate}`"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { MessengerChatRate } from '@widgets/messenger/types/chat/chat'

defineProps<{
  rate?: MessengerChatRate
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.messenger-chat-survey-log-message-layout {
  padding: 10px 14px;
  border-radius: $border-radius-lg;
  line-height: 20px;
  background-color: $chatBubble;

  &--good {
    background-color: $green100;
  }

  &--poor {
    background-color: $red100;
  }
}
</style>
